<div class="respondents-selection">
    <div (click)="isToggle = !isToggle" class="head">
        Respondents
        <i class="fa"
           [class.fa-caret-down]="isToggle"
           [class.fa-caret-up]="!isToggle"></i>
    </div>
    <div [collapse]="isToggle">
        <div class="head-list">
            <div class="m-t-20 m-b-5">
                Minimum of respondents
            </div>
            <div>
                <input [(ngModel)]="process.minRespondentAmount" type="number" />
            </div>
        </div>
        <div>
            <span>
                <input [(ngModel)]="process.allowSelfAssesment"  id="evaluation-yourself" type="checkbox">
                <label for="evaluation-yourself">Self-assessment</label>
            </span>
        </div>
        <div class="col-12 m-t-20 p-0">
            <div class="head-list mb-0">
                <div class="m-b-5">
                    Type of respondents selection
                </div>
            </div>
            <div class="type-survey">
                <span [feature]="feature.pme">
                    <input [checked]="isProcessTypeSet(processType.PME)" (click)="toggleProcessType(processType.PME)" id="checkbox-pme" type="checkbox">
                    <label for="checkbox-pme">Project team</label>
                </span>
                <span [feature]="feature.pmq">
                    <input [checked]="isProcessTypeSet(processType.PMQ)" (click)="toggleProcessType(processType.PMQ)" id="checkbox-pmq" type="checkbox">
                    <label for="checkbox-pmq">Counselee (s)</label>
                </span>
                <span [feature]="feature._360" >
                    <input [checked]="isProcessTypeSet(processType._360)"  (click)="toggle360()" id="checkbox-360" type="checkbox">
                    <label for="checkbox-360">360 Degree</label>
                </span>
                <span [feature]="feature.combined">
                    <input [checked]="isProcessTypeSet(processType.Combined)" (click)="toggleProcessType(processType.Combined)" id="checkbox-combined" type="checkbox">
                    <label for="checkbox-combined">Constructor</label>
                </span>
            </div>
            <div class="type-questionnaire" *ngIf="isProcessTypeSet(processType.PME)">
                <div class="font-weight-bold">
                    Project team
                </div>
                <div class="terms">
                    <div class="caption">
                        <span>Project code:</span>
                        <br />
                        <input [(ngModel)]="marsProjectSearch.projectCode" class="w-75 m-t-5" type="text">
                    </div>
                    <div class="caption">
                        <span>Beginning of period:</span>
                        <br />
                        <input type="text" class="w-75 m-t-5" [(ngModel)]="pmeStartDate" #beginningPeriod="bsDatepicker" placeholder="00.00.0000" bsDatepicker>
                        <i (click)="beginningPeriod.toggle()" class="fa fa-calendar"></i>
                    </div>
                    <div class="caption">
                        <span>End of the period:</span>
                        <br />
                        <input type="text" class="w-75 m-t-5" [(ngModel)]="pmeEndDate" #endPeriod="bsDatepicker" name="name" placeholder="00.00.0000" bsDatepicker />
                        <i (click)="endPeriod.toggle()" class="fa fa-calendar"></i>
                    </div>
                </div>
                <div *ngFor="let filter of pmeEmployeeFilters" class="terms mb-3 info-questionnaire">
                    <div class="caption">
                        <span>
                            Appraisee grade:
                        </span>
                        <br />
                        <div class="for-ngx-select m-t-5">
                          <app-multiple-dropdown *ngIf="filter.selectorAppraiseeGrades" displayText="Select grades" [items]="filter.selectorAppraiseeGrades" (itemChange)="selectPmeAppraiseeGrade(filter, $event)"></app-multiple-dropdown>
                        </div>
                    </div>
                    <div class="caption w-10">
                        <span>
                            Hours:
                        </span>
                        <br />
                        <input [(ngModel)]="filter.appraiseeHours" type="number" min="0" value="0">
                    </div>
                    <div class="caption">
                        <span>
                            Respondent grade:
                        </span>
                        <br />
                        <div class="for-ngx-select">
                          <app-multiple-dropdown *ngIf="filter.selectorRespondentGrades" displayText="Select grades" [items]="filter.selectorRespondentGrades" (itemChange)="selectPmeRespondentGrade(filter, $event)"></app-multiple-dropdown>
                        </div>
                    </div>
                    <div class="caption w-10">
                        <span>
                            Hours:
                        </span>
                        <br />
                        <input [(ngModel)]="filter.respondentHours"  type="number" min="0" value="0">
                    </div>
                    <div class="btn-close position-relative">
                        <i (click)="removePmeEmployeeFilter(filter)" class="mdi mdi-close"></i>
                    </div>
                </div>
                <div class="mt-2">
                    <div class="d-flex align-items-center">
                        <span (click)="pmeEmployeeFilters.push(createPmeEmployeeFilter())"  class="add-btn">
                        </span>
                    </div>
                </div>
            </div>
            <div class="type-questionnaire" *ngIf="isProcessTypeSet(processType._360)">
                <div class="font-weight-bold">
                    360 Degree
                </div>
                <div class="select-category">
                    <div class="row w-100">
                        <div class="col-sm-4 pr-0">
                            <span class="caption">
                                Select a category:
                            </span>
                            <div class="checked-grade">
                                <input [checked]="isSelectionValueSet(selectionType.GradeBelowRespondentMinAmount)" (change)="toggleSelectionValue($event, selectionType.GradeBelowRespondentMinAmount)" id="junior-grade" type="checkbox">
                                <label for="junior-grade">Junior grade</label>
                            </div>
                            <div class="checked-grade">
                                <input [checked]="isSelectionValueSet(selectionType.GradeEqualRespondentMinAmount)" (change)="toggleSelectionValue($event, selectionType.GradeEqualRespondentMinAmount)" id="same-grade" type="checkbox">
                                <label for="same-grade">Same grade</label>
                            </div>
                            <div class="checked-grade">
                                <input [checked]="isSelectionValueSet(selectionType.GradeAboveRespondentMinAmount)" (change)="toggleSelectionValue($event, selectionType.GradeAboveRespondentMinAmount)" id="senior-grade" type="checkbox">
                                <label for="senior-grade">Senior grade</label>
                            </div>
                            <div class="checked-grade">
                                <input [checked]="isSelectionValueSet(selectionType.TeamMinAmount)" (change)="toggleSelectionValue($event, selectionType.TeamMinAmount)" id="subordinates" type="checkbox">
                                <label for="subordinates">Subordinates</label>
                            </div>
                            <div class="checked-grade">
                                <input [checked]="isSelectionValueSet(selectionType.OtherRespondentMinAmount)" (change)="toggleSelectionValue($event, selectionType.OtherRespondentMinAmount)" id="other" type="checkbox">
                                <label for="other">Other</label>
                            </div>
                        </div>
                        <div class="head-list col-sm-4 mb-0 pl-0 pr-0">
                            <span class="caption">
                                Minimum of respondents:
                            </span><br />
                            <div>
                                <input [disabled]="!isSelectionValueSet(selectionType.GradeBelowRespondentMinAmount)" (focusout)="onFocusOut($event, selectionType.GradeBelowRespondentMinAmount)" [value]="getCombinedValue(selectionType.GradeBelowRespondentMinAmount)" type="number" min="0">
                            </div>
                            <div>
                                <input [disabled]="!isSelectionValueSet(selectionType.GradeEqualRespondentMinAmount)" (focusout)="onFocusOut($event, selectionType.GradeEqualRespondentMinAmount)" [value]="getCombinedValue(selectionType.GradeEqualRespondentMinAmount)" type="number" min="0" value="0">
                            </div>
                            <div>
                                <input [disabled]="!isSelectionValueSet(selectionType.GradeAboveRespondentMinAmount)" (focusout)="onFocusOut($event, selectionType.GradeAboveRespondentMinAmount)" [value]="getCombinedValue(selectionType.GradeAboveRespondentMinAmount)" type="number" min="0" value="0">
                            </div>
                            <div>
                                <input [disabled]="true" />
                            </div>
                            <div>
                                <input [disabled]="!isSelectionValueSet(selectionType.OtherRespondentMinAmount)" (focusout)="onFocusOut($event, selectionType.OtherRespondentMinAmount)" [value]="getCombinedValue(selectionType.OtherRespondentMinAmount)" type="number" min="0" value="0">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="type-questionnaire" *ngIf="isProcessTypeSet(processType.Combined)">
                <div class="m-b-20 font-weight-bold">
                    Constructor
                </div>
              <app-employee-selection *ngIf="combinedSearchSettings" 
              [employeeSelectionSettings]="combinedSearchSettings" 
              [showDistributionList]="true"
              [distributionListsSelcted]="process.distributionGroups"></app-employee-selection>
            </div>
        </div>
    </div>
</div>



